import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { COUNTRY_CODES } from '../../data/country-codes';
import { Observable, Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SM_CONSTANTS } from '../../constants/sm-constants';
import { Router } from '@angular/router';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/providers/api.service';

@Component({
  selector: 'sm-select-business-country',
  templateUrl: './select-business-country.component.html',
  styleUrls: ['./select-business-country.component.scss']
})
export class SelectBusinessCountryComponent implements OnInit {
  apisub:Subscription
  parentCountrycode:any = []
  constructor(private apiservice: ApiService,private http:HttpClient, private router: Router, private loaderservice: LoaderServiceService, private activemodal: MatDialogRef<SelectBusinessCountryComponent>) { 

    this.apisub = this.apiservice.apiResult.subscribe(resdata => {
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_COUNTRY_DATA){
        if(resdata.result){
          this.countryList = resdata.result
          this.parentCountrycode = JSON.parse(JSON.stringify(resdata.result))
          this.selectedCountryCode = this.countryList.find(
            (country) => country.dial_code === localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_COUNTRY_CODE)
          );
          this.selectedCurrency = {
            currency: this.selectedCountryCode.currency,
            currencySymbol: this.selectedCountryCode.currency_symbol,
            countryCode: this.selectedCountryCode.dial_code,
            code: this.selectedCountryCode.code
          };
        }
        this.loaderservice.showLoader = false
      }
    })


  }

  ngOnInit(): void {
    this.apiservice.getCountryData()
   
    // this.onCountrySelected('')
  }
  countryList: any[] = COUNTRY_CODES;
  selectedCountryCode: any = this.countryList.find(
    (country) => country.dial_code === localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_COUNTRY_CODE)
  )
  searchString: UntypedFormControl = new UntypedFormControl("");
  selectedCurrency:any
  onCountrySelected(event: any): void {
    console.log(event);
    this.selectedCurrency = {
      currency: this.selectedCountryCode.currency,
      currencySymbol: this.selectedCountryCode.currency_symbol,
      countryCode: this.selectedCountryCode.dial_code,
      code: this.selectedCountryCode.code
    };

    if(this.countryList.length < this.parentCountrycode.length){
      this.countryList = this.parentCountrycode;

    }
    

    // setTimeout(() => {
    //   this.selectedCountryCode = event.value
    // }, 500);
  

  }

  onKey() {
    console.log(this.searchString.value);

    this.countryList = [];
    this.selectSearch(this.searchString.value);
  }
  selectSearch(value: string) {
    let filter = value.toLowerCase();
    for (let i = 0; i < this.parentCountrycode.length; i++) {
      let option = this.parentCountrycode[i];
      if (option.name.toLowerCase().indexOf(filter) >= 0) {
        this.countryList.push(option);
      }
    }
  }



  // currency comer

  onCountryChange(countryCode: string) {

  }

  private apiUrl = 'https://restcountries.com/v3.1/alpha'; // REST Countries API

  getCurrencyByCountryCode(countryCode: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/${countryCode}`);
  }

  goToBusinessCreate(){
    sessionStorage.setItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT,JSON.stringify(this.selectedCurrency))
    this.activemodal.close({msg: 'success'})
    
  }

}
